export default {
    list: {
        title: "Stock History",
        icone: "history",
        class: "flex-1 mt-1 px-3 items-center",
        name: 'stockHistories',
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: false,
                name: "Actions",
                buttons: [{
                    text: "",
                    icon: "",
                    link: '',
                    color: 'primary'
                }],
            }
        },
        columns: [{
                name: "User",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "user",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    icone: "person"
                                },
                                {
                                    name: "type",
                                    class: "font-light text-gray-700",
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Wharhouse name",
                elements: [{
                    items: [{
                        class: "",
                        name: "name_warehouse",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Instock",
                elements: [{
                    items: [{
                        class: "",
                        name: "instock",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Previeus Instock",
                elements: [{
                    items: [{
                        class: "",
                        name: "prev_instock",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Product",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "product",
                        elements: [{
                            items: [{
                                    name: "picture",
                                    class: "font-light text-gray-700",
                                },
                                {
                                    name: "name",
                                    class: "font-light text-gray-700",
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Previous QUANTITY",
                elements: [{
                    items: [{
                        class: "",
                        name: "prev_quantity",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "QUANTITY",
                elements: [{
                    items: [{
                        class: "",
                        name: "quantity",
                        history: true,
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Type",
                elements: [{
                    items: [{
                        class: "",
                        name: "type",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "DATE",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "date",
                        date: true,
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Reason",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "reason",
                        type: "text",
                    }],
                }, ]
            },
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "rounded-full flex justify-center items-center focus:outline-none w-8 h-8 mr-3 mt-1",
            elements: [{
                icone: "delete",
                color: "danger",
                role: true,
                key: 'delete',
                tooltip: "Delete",
            }],
        },
        filters: {
            name: 'products',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "Id, Name product, code ...."
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [],
            },
        },
    },
}